import {useState, useCallback} from "react";
import {message} from "antd";
import {CsvRowData, ExportState} from "../types";

export const useExportPaymentsState = (entityLabel: string = "Umsätze") => {
    const [exportState, setExportState] = useState<ExportState>("idle");
    const [exportData, setExportData] = useState<Array<CsvRowData>>([]);
    const [exportFileName, setExportFileName] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);
    const [progress, setProgress] = useState<number>(0);
    const [isExporting, setIsExporting] = useState<boolean>(false);

    const showExportModal = useCallback((fileName: string, total?: number) => {
        setExportFileName(fileName);
        setExportState("loading");
        setIsExporting(true);
        if (total !== undefined) {
            setTotalCount(total);
        }
        setProgress(0);
    }, []);

    const handleExportSuccess = useCallback((count: number) => {
        setExportState("success");
        setIsExporting(false);
        message.success(`${count} ${entityLabel} erfolgreich exportiert`);
    }, []);

    const handleExportError = useCallback((errorMessage: string) => {
        setExportState("error");
        setIsExporting(false);
        message.error(errorMessage);
    }, []);

    const updateProgress = useCallback((newProgress: number) => {
        setProgress(newProgress);
    }, []);

    const resetExport = useCallback(() => {
        setExportState("idle");
        setExportData([]);
        setExportFileName("");
        setTotalCount(0);
        setProgress(0);
        setIsExporting(false);
    }, []);

    return {
        exportState,
        exportData,
        setExportData,
        exportFileName,
        totalCount,
        setTotalCount,
        progress,
        updateProgress,
        isExporting,
        setIsExporting,
        showExportModal,
        handleExportSuccess,
        handleExportError,
        resetExport,
    };
};
